import { trackEvent } from '@nile/mantine-theme/analytics'

/** Segment emitter wrapper: swallows throws + strips null/undefined props. */
export function emit(eventName: string, properties: Record<string, unknown> = {}): void {
    try {
        const sanitized: Record<string, unknown> = {}
        for (const [key, value] of Object.entries(properties)) {
            if (value === undefined || value === null) continue
            sanitized[key] = value
        }
        trackEvent(eventName, sanitized)
    } catch {
        // Analytics must never block a real flow.
    }
}
